module.exports = __webpack_public_path__ + "static/media/DSC09660.d9b4ad07.jpg";